var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover=no"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.72 8.45977L13.387 4.31177C12.919 3.94768 12.343 3.75 11.75 3.75C11.157 3.75 10.581 3.94768 10.113 4.31177L4.779 8.45977C4.45844 8.70905 4.19909 9.0283 4.02076 9.39312C3.84242 9.75794 3.74981 10.1587 3.75 10.5648V17.7648C3.75 18.2952 3.96071 18.8039 4.33579 19.179C4.71086 19.5541 5.21957 19.7648 5.75 19.7648H17.75C18.2804 19.7648 18.7891 19.5541 19.1642 19.179C19.5393 18.8039 19.75 18.2952 19.75 17.7648V10.5648C19.75 9.74177 19.37 8.96477 18.72 8.45977Z",
    fill: "white",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 43",
    x1: 8,
    y1: 16,
    x2: 16,
    y2: 16,
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuDashboard);
export default __webpack_public_path__ + "static/media/ic-menu-dashboard.700ca277c78174e2362b1c975e8bc67e.svg";
export { ForwardRef as ReactComponent };